export const QUOTA_LIMIT_TYPE_MIN = 'min';

export const isMinimumQuotaLimitType = (type) => type === QUOTA_LIMIT_TYPE_MIN;

/**
 * Whether a summary quota row is a minimum-responses row.
 * On a row, absent quotaLimitType means max. On a question node, use deriveQuotaMode.
 */
export const isMinimumSummaryQuotaRow = (row) =>
  isMinimumQuotaLimitType(row?.quotaLimitType);
